export class ErpStoreClient {
  constructor(
    technicalId,
    clientCode,
    clientName,
    clientPostalCode,
    clientStoreCode
  ) {
    this.technicalId = technicalId
    this.clientCode = clientCode
    this.clientName = clientName
    this.clientPostalCode = clientPostalCode
    this.clientStoreCode = clientStoreCode
  }
}
